import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  bannerContainer: {
    ...Commons.flexRow,
    backgroundImage: `linear-gradient(144deg, ${colors.black} 30%, ${colors.orange})`,
    minHeight: "50vh",
    width: "100%",
    borderRadius: 24,
    boxShadow: `0 0 60px 0px ${colors.white}50`,
    marginBottom: 60,
    animation: "$neonBgLoopWhite 3s linear infinite",
    boxSizing: "border-box",
    padding: 30,
    gap: 30,
    [Commons.midQuery]: {
      gap: 6,
      flexDirection: "column",
      height: "unset",
    },
  },
  columnBannerLeft: {
    ...Commons.flexCenter,
    flex: 1,
    maxWidth: "50%",
    position: "relative",
    height: "100%",
    [Commons.midQuery]: {
      height: "unset",
      maxWidth: "unset",
      flex: "unset",
    },
  },
  columnBanner: {
    flex: 2,
    maxWidth: "75%",
    display: "block",
    [Commons.midQuery]: {
      maxWidth: "unset",
      flex: "unset",
    },
  },
  containerImageLogo: {
    ...Commons.flexCenter,
    position: "absolute",
    width: "25dvw",
    height: "auto",
    aspectRatio: "1 / 1",
    borderRadius: "50%",
    border: `6px solid ${colors.white}`,
    boxShadow: colors.shadowWhiteInset,
    padding: 60,
    backgroundColor: colors.black,
    boxSizing: "border-box",
    zIndex: 0,
    maxWidth: 300,
    [Commons.midQuery]: {
      maxWidth: 240,
      width: "90dvw",
      position: "relative",
      padding: 90,
      marginBottom: 30,
    },
  },
  imageLogo: {
    width: "120%",
    height: "auto",
    aspectRatio: "1 / 1",
    position: "absolute",
  },
  overlayVideo: {
    position: "relative",
    width: "100%",
    height: "25dvw",
    borderRadius: "50%",
    backgroundColor: "transparent",
    zIndex: 1,
    maxHeight: 300,
    [Commons.smallQuery]: {
      position: "absolute",
    },
  },
  titleBanner: {
    color: colors.white,
    fontWeight: "bold",
    fontSize: 42,
    margin: 0,
    [Commons.smallQuery]: {
      fontSize: 24,
    },
  },
  descriptionBanner: {
    color: colors.white,
    fontSize: 24,
    margin: "24px 0 48px 0",
    textAlign: "justify",
    whiteSpace: "break-spaces",
    [Commons.smallQuery]: {
      margin: "12px 0 48px 0",
      fontSize: 18,
      textAlign: "left",
    },
  },
  buttonBanner: {
    ...Commons.defaultButton,
    color: `${colors.white} !important`,
    fontWeight: "500 !important",
    fontSize: "24px !important",
    backgroundColor: colors.black,
    borderRadius: 24,
    padding: "12px 24px",
    transition: "all 0.2s",
    boxShadow: colors.shadow,
    textDecoration: "unset !important",
    textWrap: "nowrap",
    border: `3px solid ${colors.orange} !important`,
    "&:hover": {
      boxShadow: `0 0 12px 0px ${colors.white}`,
      backgroundColor: colors.orange,
    },
    [Commons.smallQuery]: {
      fontSize: "18px !important",
    },
  },
  "@keyframes neonBgLoopWhite": {
    "0%": {
      boxShadow: `0 0 50px 3px ${colors.white}30`,
    },
    "50%": {
      boxShadow: `0 0 50px 3px ${colors.white}75`,
    },
    "100%": {
      boxShadow: `0 0 50px 3px ${colors.white}30`,
    },
  },
});

export default styles;
